import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="16" height="17" viewBox="0 0 16 17" fill="none">
      <g clipPath="url(#clip0_1723_7613)">
        <path
          d="M2.18294 10.6969C1.61632 9.96082 1.33301 9.59275 1.33301 8.49984C1.33301 7.40692 1.61632 7.03885 2.18294 6.30272C3.31432 4.83288 5.21175 3.1665 7.99967 3.1665C10.7876 3.1665 12.685 4.83288 13.8164 6.30272C14.383 7.03885 14.6663 7.40692 14.6663 8.49984C14.6663 9.59275 14.383 9.96082 13.8164 10.6969C12.685 12.1668 10.7876 13.8332 7.99967 13.8332C5.21175 13.8332 3.31432 12.1668 2.18294 10.6969Z"
          stroke="white"
          strokeOpacity="0.5"
        />
        <path
          d="M10 8.5C10 9.60457 9.10457 10.5 8 10.5C6.89543 10.5 6 9.60457 6 8.5C6 7.39543 6.89543 6.5 8 6.5C9.10457 6.5 10 7.39543 10 8.5Z"
          stroke="white"
          strokeOpacity="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_1723_7613">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Icon;
